import { PARTNERS } from "../../data/content";

export const Partners = () => {
  return (
    <section className="py-20 bg-white border-t border-neutral-200" data-testid="partners-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-10">
          <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-3 font-medium">
            Laboratory partners & alliances
          </div>
          <h3 className="font-heading text-2xl md:text-3xl font-thin tracking-tight">
            Authentic stock from <span className="font-black">verified manufacturers</span>.
          </h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 border-l border-t border-neutral-200">
          {PARTNERS.map((p) => (
            <div
              key={p}
              className="border-r border-b border-neutral-200 py-8 px-4 flex items-center justify-center hover:bg-neutral-50 transition-colors"
              data-testid={`partner-${p.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <span className="font-heading text-xl md:text-2xl font-black tracking-tight text-neutral-400 hover:text-black transition-colors">
                {p}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
